import { useEffect, useState } from "react";
import { brand, navLinks } from "@/mocks/homeData";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 md:h-20 items-center justify-between gap-4">
          <a
            href="#home"
            className="flex items-center gap-2.5 group cursor-pointer"
            aria-label={`${brand.name} 返回首页`}
          >
            <span
              className={`w-9 h-9 flex items-center justify-center rounded-md transition-colors ${
                scrolled || menuOpen
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-primary-600"
              }`}
            >
              <i className="ri-radar-line text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading font-bold text-lg tracking-wide transition-colors ${
                  scrolled || menuOpen ? "text-foreground-950" : "text-background-50"
                }`}
              >
                {brand.name}
              </span>
              <span
                className={`font-label text-[10px] mt-0.5 tracking-widest transition-colors ${
                  scrolled || menuOpen ? "text-foreground-500" : "text-background-200"
                }`}
              >
                HOT TOPIC NAVIGATOR
              </span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`font-label text-sm px-3 py-2 rounded-md transition-colors cursor-pointer ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                    : "text-background-100 hover:text-background-50 hover:bg-background-50/15"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#contact"
              className="whitespace-nowrap cursor-pointer font-label text-sm px-4 py-2 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
            >
              订阅更新
            </a>
          </div>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer transition-colors ${
              scrolled || menuOpen
                ? "text-foreground-900 hover:bg-background-200"
                : "text-background-50 hover:bg-background-50/15"
            }`}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <nav className="px-4 py-3 flex flex-col" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="font-label text-sm text-foreground-700 py-3 border-b border-background-100 hover:text-primary-600 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setMenuOpen(false)}
              className="mt-4 whitespace-nowrap cursor-pointer text-center font-label text-sm px-4 py-3 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
            >
              订阅更新
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}